import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_CONSIGNERS = createRequestTypes('GET_CONSIGNERS');
export const CREATE_CONSIGNER = createRequestTypes('CREATE_CONSIGNER');
export const GET_CONSIGNER_DETAILS = createRequestTypes('GET_CONSIGNER_DETAILS');

export const GET_CONSIGNERS_TRANCATION_LIST = createRequestTypes('GET_CONSIGNERS_TRANCATION_LIST');

export const GET_CONSIGNERS_TRANCATION_LIST_NEW = createRequestTypes('GET_CONSIGNERS_TRANCATION_LIST_NEW');

export const ADD_NEW_TRANSACTION = createRequestTypes('ADD_NEW_TRANSACTION');

export const SAVE_ADDRESS = createRequestTypes('SAVE_ADDRESS');
export const CREATE_ADDRESS = createRequestTypes('CREATE_ADDRESS');
export const SAVE_GST = createRequestTypes('SAVE_GST');
export const CREATE_GST = createRequestTypes('CREATE_GST');
export const DELETE_POC = createRequestTypes('DELETE_POC');
export const EDIT_BASIC_DETAILS = createRequestTypes('EDIT_BASIC_DETAILS');
export const EDIT_VPA_DETAILS = createRequestTypes('EDIT_VPA_DETAILS');
export const CREATE_VPA_DETAILS = createRequestTypes('CREATE_VPA_DETAILS');
export const DELETE_ADDRESS = createRequestTypes('DELETE_ADDRESS');
export const DELETE_GST = createRequestTypes('DELETE_GST');
export const UPLOAD_DOCUMENT = createRequestTypes('UPLOAD_DOCUMENT');
export const RESET_FILE_UPLOAD = createRequestTypes('RESET_FILE_UPLOAD');
export const RESET_VIEW_URL = createRequestTypes('RESET_VIEW_URL');
export const VIEW_FILE = createRequestTypes('VIEW_FILE');
export const UPLOAD_GST = createRequestTypes('UPLOAD_GST');
export const VIEW_GST = createRequestTypes('VIEW_GST');
export const GET_CONSIGNER_TYPE = createRequestTypes('GET_CONSIGNER_TYPE');

export const GET_CASHBACK_TYPE = createRequestTypes('GET_CASHBACK_TYPE');

export const GET_WALLET_BALANCE = createRequestTypes('GET_WALLET_BALANCE');

export const GET_CONSIGNER_STATUS = createRequestTypes('GET_CONSIGNER_STATUS');
export const EDIT_COMPLIANCES = createRequestTypes('EDIT_COMPLIANCES');
export const EDIT_PAYMENT = createRequestTypes('EDIT_PAYMENT');
export const EDIT_BUSINESS = createRequestTypes('EDIT_BUSINESS');
export const EDIT_NOTIFICATION = createRequestTypes('EDIT_NOTIFICATION');
export const UPLOAD_CONSIGNER_FILE = createRequestTypes('UPLOAD_CONSIGNER_FILE');
export const VIEW_CONSIGNER_FILE = createRequestTypes('VIEW_CONSIGNER_FILE');
export const GET_VPA_DETAILS = createRequestTypes('GET_VPA_DETAILS');
export const GET_SEARCH_RESULTS = createRequestTypes('GET_SEARCH_RESULTS');
export const RESET_EDITED_STATUS = createRequestTypes('RESET_EDITED_STATUS');
export const RESET_FILE_URL = createRequestTypes('RESET_FILE_URL');
export const CLEAR_FLAGS = createRequestTypes('CLEAR_FLAGS');
export const GET_CONSIGNER_BILLING_DETAILS = createRequestTypes('GET_CONSIGNER_BILLING_DETAILS');
export const UPDATE_BILLING_ACCOUNT = createRequestTypes('UPDATE_BILLING_ACCOUNT');
export const UPDATE_PAN_GST = createRequestTypes('UPDATE_PAN_GST');
export const VIEW_PRE_SIGNED_URL = createRequestTypes('VIEW_PRE_SIGNED_URL');
export const UPLOAD_PRE_SIGNED_URL = createRequestTypes('UPLOAD_PRE_SIGNED_URL');
export const UPLOAD_TO_PRE_SIGNED_URL = createRequestTypes('UPLOAD_TO_PRE_SIGNED_URL');
export const RESET_WALLET_TRANSACTION = createRequestTypes('RESET_WALLET_TRANSACTION');
export const GET_PAYMENT_SELECTION_TYPES = createRequestTypes('GET_PAYMENT_SELECTION_TYPES');
export const GET_BUSINESS_DETAILS = createRequestTypes('GET_BUSINESS_DETAILS');
export const UPLOAD_PAYMENT_DOC = createRequestTypes('UPLOAD_PAYMENT_DOC');
export const GET_PAYMENT_IMAGE_URL = createRequestTypes('GET_PAYMENT_IMAGE_URL');
export const SUBMIT_CONFIRMATION = createRequestTypes('SUBMIT_CONFIRMATION');
// export const GET_CONSIGNER_WALLLET_BALANCE = createRequestTypes('GET_CONSIGNER_WALLLET_BALANCE');

export const allConsigners = {
  request: (params) => createAction(GET_CONSIGNERS[REQUEST], { params }),
  success: (response) => createAction(GET_CONSIGNERS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNERS[FAILURE], { response }),
};

export const uploadConsignerFile = {
  request: (params) => createAction(UPLOAD_CONSIGNER_FILE[REQUEST], { params }),
  success: (response, params) => createAction(UPLOAD_CONSIGNER_FILE[SUCCESS], { response, params }),
  failure: (response) => createAction(UPLOAD_CONSIGNER_FILE[FAILURE], { response }),
  resetEditedStatus: () => createAction(RESET_EDITED_STATUS),
};

export const getSearchResults = {
  request: (params) => createAction(GET_SEARCH_RESULTS[REQUEST], { params }),
  success: (response, params) => createAction(GET_SEARCH_RESULTS[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_SEARCH_RESULTS[FAILURE], { response }),
};

export const viewConsignerFile = {
  request: (params) => createAction(VIEW_CONSIGNER_FILE[REQUEST], { params }),
  success: (response) => createAction(VIEW_CONSIGNER_FILE[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_CONSIGNER_FILE[FAILURE], { response }),
};

export const consignerDetails = {
  request: (params) => createAction(GET_CONSIGNER_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_CONSIGNER_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_DETAILS[FAILURE], { response }),
  resetFileUpload: () => createAction(RESET_FILE_UPLOAD),
  resetFileUrl: () => createAction(RESET_FILE_URL),
  resetViewUrl: () => createAction(RESET_VIEW_URL),
};

export const getVpaDetails = {
  request: (params) => createAction(GET_VPA_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_VPA_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_VPA_DETAILS[FAILURE], { response }),
};

export const getConsignerType = {
  request: () => createAction(GET_CONSIGNER_TYPE[REQUEST]),
  success: (response) => createAction(GET_CONSIGNER_TYPE[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_TYPE[FAILURE], { response }),
};

export const getConsignerStatus = {
  request: () => createAction(GET_CONSIGNER_STATUS[REQUEST]),
  success: (response) => createAction(GET_CONSIGNER_STATUS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_STATUS[FAILURE], { response }),
};

export const viewFile = {
  request: (file) => createAction(VIEW_FILE[REQUEST], { file }),
  success: (response) => createAction(VIEW_FILE[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_FILE[FAILURE], { response }),
};

// POST API Actions

export const createConsigner = {
  request: (payload) => createAction(CREATE_CONSIGNER[REQUEST], { payload }),
  success: (response) => createAction(CREATE_CONSIGNER[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_CONSIGNER[FAILURE], { response }),
};

export const addNewTransactionAction = {
  request: (payload) => createAction(ADD_NEW_TRANSACTION[REQUEST], { payload }),
  success: (response) => createAction(ADD_NEW_TRANSACTION[SUCCESS], { response }),
  failure: (response) => createAction(ADD_NEW_TRANSACTION[FAILURE], { response }),
};

export const editCompliances = {
  request: (payload) => createAction(EDIT_COMPLIANCES[REQUEST], { payload }),
  success: (response) => createAction(EDIT_COMPLIANCES[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_COMPLIANCES[FAILURE], { response }),
};

export const editPayment = {
  request: (payload) => createAction(EDIT_PAYMENT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_PAYMENT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_PAYMENT[FAILURE], { response }),
};

export const editBusiness = {
  request: (payload) => createAction(EDIT_BUSINESS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_BUSINESS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_BUSINESS[FAILURE], { response }),
};

export const editNotification = {
  request: (payload) => createAction(EDIT_NOTIFICATION[REQUEST], { payload }),
  success: (response) => createAction(EDIT_NOTIFICATION[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_NOTIFICATION[FAILURE], { response }),
  clearFlags: () => createAction(CLEAR_FLAGS),
};

export const saveEditedAddress = {
  request: (payload) => createAction(SAVE_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(SAVE_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(SAVE_ADDRESS[FAILURE], { response }),
};

export const createNewAddress = {
  request: (payload) => createAction(CREATE_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(CREATE_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_ADDRESS[FAILURE], { response }),
};

export const editBasicDetails = {
  request: (payload) => createAction(EDIT_BASIC_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_BASIC_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_BASIC_DETAILS[FAILURE], { response }),
};

export const editVpaDetails = {
  request: (payload) => createAction(EDIT_VPA_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_VPA_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_VPA_DETAILS[FAILURE], { response }),
};

export const createVpaDetails = {
  request: (payload) => createAction(CREATE_VPA_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(CREATE_VPA_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_VPA_DETAILS[FAILURE], { response }),
};

export const saveConsignerGst = {
  request: (payload) => createAction(SAVE_GST[REQUEST], { payload }),
  success: (response) => createAction(SAVE_GST[SUCCESS], { response }),
  failure: (response) => createAction(SAVE_GST[FAILURE], { response }),
};

export const createConsignerGst = {
  request: (payload) => createAction(CREATE_GST[REQUEST], { payload }),
  success: (response) => createAction(CREATE_GST[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_GST[FAILURE], { response }),
};

export const uploadDocument = {
  request: (payload) => createAction(UPLOAD_DOCUMENT[REQUEST], { payload }),
  success: (response) => createAction(UPLOAD_DOCUMENT[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_DOCUMENT[FAILURE], { response }),
};

export const uploadGst = {
  request: (params) => createAction(UPLOAD_GST[REQUEST], { params }),
  success: (response, params) => createAction(UPLOAD_GST[SUCCESS], { response, params }),
  failure: (response) => createAction(UPLOAD_GST[FAILURE], { response }),
};

export const uploadpaymentDoc = {
  request: (params) => createAction(UPLOAD_PAYMENT_DOC[REQUEST], { params }),
  success: (response, params) => createAction(UPLOAD_PAYMENT_DOC[SUCCESS], { response, params }),
  failure: (response) => createAction(UPLOAD_PAYMENT_DOC[FAILURE], { response }),
};

export const viewGst = {
  request: (params) => createAction(VIEW_GST[REQUEST], { params }),
  success: (response, params) => createAction(VIEW_GST[SUCCESS], { response, params }),
  failure: (response) => createAction(VIEW_GST[FAILURE], { response }),
};

export const deletePoc = {
  request: (id) => createAction(DELETE_POC[REQUEST], { id }),
  success: (response) => createAction(DELETE_POC[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_POC[FAILURE], { response }),
};

export const deleteAddress = {
  request: (id) => createAction(DELETE_ADDRESS[REQUEST], { id }),
  success: (response) => createAction(DELETE_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_ADDRESS[FAILURE], { response }),
};

export const deleteGst = {
  request: (id) => createAction(DELETE_GST[REQUEST], { id }),
  success: (response) => createAction(DELETE_GST[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_GST[FAILURE], { response }),
};

export const consignerBillingDetails = {
  request: (params) => createAction(GET_CONSIGNER_BILLING_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_CONSIGNER_BILLING_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_BILLING_DETAILS[FAILURE], { response }),
  resetFileUpload: () => createAction(RESET_FILE_UPLOAD),
  resetFileUrl: () => createAction(RESET_FILE_URL),
  resetViewUrl: () => createAction(RESET_VIEW_URL),
};

export const updateBillingAccount = {
  request: (payload) => createAction(UPDATE_BILLING_ACCOUNT[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_BILLING_ACCOUNT[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_BILLING_ACCOUNT[FAILURE], { response }),
};

export const updatePanGst = {
  request: (payload) => createAction(UPDATE_PAN_GST[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_PAN_GST[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_PAN_GST[FAILURE], { response }),
};

export const viewPreSignedUrl = {
  request: (payload) => createAction(VIEW_PRE_SIGNED_URL[REQUEST], { payload }),
  success: (response) => createAction(VIEW_PRE_SIGNED_URL[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_PRE_SIGNED_URL[FAILURE], { response }),
};

export const uploadPreSignedUrl = {
  request: (payload) => createAction(UPLOAD_PRE_SIGNED_URL[REQUEST], { payload }),
  success: (response) => createAction(UPLOAD_PRE_SIGNED_URL[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_PRE_SIGNED_URL[FAILURE], { response }),
};

export const uploadToPreSignedUrl = {
  request: (payload) => createAction(UPLOAD_TO_PRE_SIGNED_URL[REQUEST], { payload }),
  success: (response) => createAction(UPLOAD_TO_PRE_SIGNED_URL[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_TO_PRE_SIGNED_URL[FAILURE], { response }),
};

// export const consignerTransactionsListAction = {
//   request: (params) => createAction(GET_CONSIGNERS_TRANCATION_LIST[REQUEST], { params }),
//   success: (response) => createAction(GET_CONSIGNERS_TRANCATION_LIST[SUCCESS], { response }),
//   failure: (response) => createAction(GET_CONSIGNERS_TRANCATION_LIST[FAILURE], { response }),
// };

export const consignerTransactionsListActionNew = {
  request: (params) => createAction(GET_CONSIGNERS_TRANCATION_LIST_NEW[REQUEST], { params }),
  success: (response) => createAction(GET_CONSIGNERS_TRANCATION_LIST_NEW[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNERS_TRANCATION_LIST_NEW[FAILURE], { response }),
  resetWalletTransactions: () => createAction(RESET_WALLET_TRANSACTION),
};

export const getCashBackTypeAction = {
  request: (params) => createAction(GET_CASHBACK_TYPE[REQUEST], { params }),
  success: (response) => createAction(GET_CASHBACK_TYPE[SUCCESS], { response }),
  failure: (response) => createAction(GET_CASHBACK_TYPE[FAILURE], { response }),
};

export const getWalletBalance = {
  request: (params) => createAction(GET_WALLET_BALANCE[REQUEST], { params }),
  success: (response) => createAction(GET_WALLET_BALANCE[SUCCESS], { response }),
  failure: (response) => createAction(GET_WALLET_BALANCE[FAILURE], { response }),
};

export const getConsignerPaymentModes = {
  request: (params) => createAction(GET_PAYMENT_SELECTION_TYPES[REQUEST], { params }),
  success: (response) => createAction(GET_PAYMENT_SELECTION_TYPES[SUCCESS], { response }),
  failure: (response) => createAction(GET_PAYMENT_SELECTION_TYPES[FAILURE], { response }),
};

export const getConsignerBusinessDetails = {
  request: (params) => createAction(GET_BUSINESS_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_BUSINESS_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_BUSINESS_DETAILS[FAILURE], { response }),
};

export const getViewImageUrl = {
  request: (params) => createAction(GET_PAYMENT_IMAGE_URL[REQUEST], { params }),
  success: (response) => createAction(GET_PAYMENT_IMAGE_URL[SUCCESS], { response }),
  failure: (response) => createAction(GET_PAYMENT_IMAGE_URL[FAILURE], { response }),
};

export const submitConfirmation = {
  request: (params) => createAction(SUBMIT_CONFIRMATION[REQUEST], { params }),
  success: (response) => createAction(SUBMIT_CONFIRMATION[SUCCESS], { response }),
  failure: (response) => createAction(SUBMIT_CONFIRMATION[FAILURE], { response }),
};
